import UserDetailComponent from 'src/components/features/superAdmin/userDetailComponent';

const ListUserPage = () => <UserDetailComponent />;

export default ListUserPage;
